import { useWordPressBar } from "../../AppProvider";
import { InnerHTML } from "./BenefitsHeader";

const DynamicBars = () => {
  const { topBar } = useWordPressBar();

  return topBar ? (
    <InnerHTML html={topBar.style + topBar.js + topBar.html} />
  ) : (
    <></>
  );
};

export default DynamicBars;
